import { createContext } from 'react';

export type EditAmountCtx = {
  shouldOpenEditAmountModal: boolean;
};

const EditAmountDialogueContext = createContext<EditAmountCtx>({
  shouldOpenEditAmountModal: false,
});

export default EditAmountDialogueContext;
